import React from "react"
import dayjs from "utils/dates"

// store
import { useAuth } from "store/auth"

// configs
import config from "config"

// firebase
import {
  collection,
  query,
  where,
  onSnapshot,
  orderBy,
  limit,
} from "firebase/firestore"
import { Firestore } from "services/firebase"

const ReservationContext = React.createContext()

function useReservations() {
  const context = React.useContext(ReservationContext)
  if (!context) {
    throw new Error(`useReservations must be used within a ReservationProvider`)
  }

  const [reservations] = context

  return {
    list: reservations,
    currentReservations: reservations.filter((reservation) => {
      const now = dayjs().startOf("day")
      const reservationTime = dayjs(reservation.datetime.toDate())
      return reservationTime.isAfter(now)
    }),
  }
}

function ReservationProvider(props) {
  const { isAuthentificated, user } = useAuth()

  const [reservations, setReservations] = React.useState([])

  const subscription = React.useRef()

  React.useEffect(() => {
    if (!isAuthentificated) return

    subscription.current = onSnapshot(
      query(
        collection(Firestore, "reservations"),
        where("resto_key", "==", config.key),
        where(`creator_uid`, "==", user.uid),
        orderBy("created_at", "desc"),
        limit(50)
      ),
      async (querySnapshot) => {
        const data = []

        querySnapshot.forEach((doc) => {
          const item = {
            id: doc.id,
            ...doc.data({ serverTimestamps: "estimate" }),
          }

          data.push(item)
        })

        setReservations(data)
      }
    )

    return () => subscription.current()
  }, [isAuthentificated, user])

  return (
    <ReservationContext.Provider
      value={[reservations, setReservations]}
      {...props}
    />
  )
}

export { ReservationProvider, useReservations }
